var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');

require('./Grid.less');

var Favorites = require('front/components/Favorites/Favorites');
var ArticleItem = require('front/components/ArticleItem/ArticleItem');
require('front/components/MagItem/MagItem');
require('front/components/Banner/Banner');
require('front/components/Featured/Featured');
var PhotoRecent = require('front/components/PhotoRecent/PhotoRecent');
var VideoRecent = require('front/components/VideoRecent/VideoRecent');
var Featured = require('front/components/Featured/Featured');
require('front/components/Button/Button');
var MagItem = require('front/components/MagItem/MagItem.js');
var BroadcastsFavorite = require('front/components/BroadcastsFavorite/BroadcastsFavorite.js');

module.exports = Backbone.View.extend({
    el: '.Grid',

    initialize: function (options) {
        this.$favorites = this.$('.Favorites');
        if (this.$favorites.size()) {
            this.favorites = new Favorites({
                el: this.$favorites
            });
        }

        this.$photoRecent = this.$('.PhotoRecent');
        if (this.$photoRecent.size()) {
            this.photoRecent = new PhotoRecent({
                el: this.$photoRecent
            });
        }

        this.$videoRecent = this.$('.VideoRecent');
        if (this.$videoRecent.size()) {
            this.videoRecent = new VideoRecent({
                el: this.$videoRecent
            });
        }

        this.$featured = this.$('.Featured');
        if (this.$featured.size()) {
            this.featured = new Featured({
                el: this.$featured
            });
        }

        _.each(this.$('.ArticleItem'), function (el) {
            new ArticleItem({el: el});
        });

        this.count = this.$('.ArticleItem').size();

        new MagItem({
            el: this.$('.MagItem')
        });

        this.$broadcastsFavorite = this.$('.BroadcastsFavorite');
        if (this.$broadcastsFavorite.size()) {
            this.broadcatsFavorite = new BroadcastsFavorite({
                el: this.$broadcastsFavorite
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Grid/Grid.js
// module id = 174
// module chunks = 0